import styled from "styled-components";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import UserProfile from "../../components/profile/UserProfile";
import UserProgram from "../../components/profile/UserProgram";

function Profile(){
    return (
        <Container>
            <Header />
            <div className="inner">
                <Content>
                    <UserProfile />
                    <UserProgram />
                </Content>
            </div>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
    
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 80px;
    margin-top: 160px;
    margin-bottom: 120px;
`



export default Profile;